import styled from "styled-components";

type MissionListContentProps = {
  isShowAssignPicker: boolean;
};

export const MissionListContentStyled = styled.div<MissionListContentProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100vh;
  overflow: ${(props) => (props.isShowAssignPicker ? "hidden" : "hidden")};

  button {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const MissionListScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px;
  padding-bottom: 24px;
`;
